// ABOUTME: Tab configuration for relation-portal service desk.
// ABOUTME: workscreen for active tickets, history for closed tickets.

import InboxIcon from '@mui/icons-material/Inbox';
import HistoryIcon from '@mui/icons-material/History';

export const relationServiceConfig = () => {
    return {
        workscreen: {
            title: 'workscreen',
            icon: <InboxIcon/>,
        },
        history: {
            title: 'history',
            icon: <HistoryIcon/>,
        },
    };
};
